import script from "./promoPageRegForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./promoPageRegForm.vue?vue&type=script&lang=ts&setup=true"

import "./promoPageRegForm.vue?vue&type=style&index=0&id=0cd58376&lang=scss&scoped=true"

import exportComponent from "/home/sergiy/projects/magnetics/promo.land/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cd58376"]])

export default __exports__